import type { InviteImage } from '../types';
import { CDN_BASE } from '../config/cdn';

export const PLACEHOLDER_IMAGES: InviteImage[] = [
  { id: -1, section: 'gallery', url: `${CDN_BASE}/images/placeholders/wedding-1.jpg`, order: 0, metadata: {} },
  { id: -2, section: 'gallery', url: `${CDN_BASE}/images/placeholders/wedding-2.jpg`, order: 1, metadata: {} },
  { id: -3, section: 'gallery', url: `${CDN_BASE}/images/placeholders/wedding-3.jpg`, order: 2, metadata: {} },
  { id: -4, section: 'gallery', url: `${CDN_BASE}/images/placeholders/wedding-4.jpg`, order: 3, metadata: {} },
  { id: -5, section: 'gallery', url: `${CDN_BASE}/images/placeholders/wedding-6.jpg`, order: 4, metadata: {} },
];

const PLACEHOLDER_MAP = new Map(PLACEHOLDER_IMAGES.map(img => [img.id, img]));

/** Returns the placeholder image object for a negative ID, or undefined. */
export function getPlaceholderImage(id: number): InviteImage | undefined {
  return PLACEHOLDER_MAP.get(id);
}

/** Returns placeholder image objects for all negative IDs in the list. */
export function resolvePlaceholderImages(imageIds: number[]): InviteImage[] {
  return imageIds
    .filter(id => id < 0)
    .map(id => PLACEHOLDER_MAP.get(id))
    .filter((img): img is InviteImage => img != null);
}
